export default __webpack_public_path__ + "static/media/skip-bg.0d5b0eff.png";